import { Observable, of, OperatorFunction, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { APIResponse, HttpResponse, ModelTransformer } from './common.model';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const mapAPIResponse = <T>() =>
    map((data: APIResponse<T>) => {
        if (!data.isSuccess) {
            throw new Error(data.message);
        }
        return data.entity;
    });

// TODO remove 'any' and fix usages. usages of mapRetrieveUpdateList may no longer need to explicitly specify TOut
const mapRetrieveUpdateList =
    <TOut = any, TIn = TOut>(transformer?: ModelTransformer<TOut, TIn>) =>
    (source: Observable<APIResponse<TIn>>) =>
        source.pipe(
            mapAPIResponse(),
            map((entity) =>
                transformer == null
                    ? (entity as any as TOut)
                    : transformer.transform(entity),
            ),
        );

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const mapCreate =
    () =>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    <T>(source: Observable<HttpResponse>) =>
        source.pipe(
            map((resp) => {
                if (resp.status !== 201) {
                    throw new Error();
                }
                return resp;
            }),
            map((resp) => resp.headers.get('location')),
        );

export const mapRetrieve = mapRetrieveUpdateList;

export const mapUpdate = mapRetrieveUpdateList;

export const mapDelete =
    () =>
    <T>(source: Observable<APIResponse<T>>) =>
        source.pipe(
            mapAPIResponse(),
            map(() => true),
        );

export const mapList = mapRetrieveUpdateList;

/** @deprecated this is for those weird apis. this expects parent to have used {observe: 'body'} */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const mapBoolean = () =>
    map((data: boolean | string) => {
        if (data !== true || String(data).toLowerCase() !== 'true') {
            throw new Error();
        }
        return true;
    });

export const catchErrorLogRet = <T, R = T>(
    ret?: any,
): OperatorFunction<T, R> => {
    return pipe(
        catchError((err) => {
            console.log(err);
            return of(ret);
        }),
    );
};
